import { SourcingStageStat } from 'api-clients/monolith';
import { FormattedMessage } from 'react-intl';

import { Skeleton } from '@/components/ui/skeleton';
import { Typography } from '@/components/ui/typography';

import { BarChart } from './bar-chart';

interface ChartProps {
  funnelData: SourcingStageStat[];
}

export function Chart({ funnelData }: ChartProps) {
  return (
    <div className="border-fx-neutral-300 flex-2 flex flex-col gap-4 rounded-lg border bg-white p-4 shadow-sm">
      <Typography variant="h6" as="h2">
        <FormattedMessage defaultMessage="Hiring Funnel" />
      </Typography>
      <BarChart funnelData={funnelData} />
    </div>
  );
}

Chart.Skeleton = function ChartSkeleton() {
  return (
    <div className="border-fx-neutral-300 flex-2 flex flex-col gap-4 rounded-lg border bg-white p-4 shadow-sm">
      <Typography variant="h6" as="h2">
        <FormattedMessage defaultMessage="Hiring Funnel" />
      </Typography>
      <Skeleton className="h-full w-full" />
    </div>
  );
};
